document.addEventListener("DOMContentLoaded", function () {
  // Get the current URL
  const url = new URLSearchParams(window.location.search);
  const param = url.get('user');
  const header = document.querySelector('.login-header')

  // Update header text
  if (param == 'retailer') {
    header.textContent = 'Retailer Login'
  } else if (param == 'veterinarian') {
    header.textContent = 'Wholesale Login'
  }

  header.classList.remove('visually-hidden')
});